import React from 'react';
import { Search, Bell, User, Menu } from 'lucide-react';
import './Header.css';

const Header = ({ title, onToggleSidebar }) => {
  return (
    <header className="main-header">
      <div className="header-left">
        <button 
          type="button" 
          className="mobile-menu-btn" 
          onClick={onToggleSidebar}
          aria-label="Toggle Navigation"
        >
          <Menu size={22} />
        </button>
        <h1 className="page-title">{title}</h1>
      </div>

      {/* <div className="header-right">
        <div className="search-bar">
          <Search size={18} className="search-icon" />
          <input type="text" placeholder="Search anything..." />
        </div>

        <div className="header-actions">
          <button className="icon-btn">
            <Bell size={20} />
            <span className="notification-badge"></span>
          </button>
          
          <div className="user-profile">
            <div className="user-info">
              <span className="user-name">Admin User</span>
              <span className="user-role">Super Admin</span>
            </div>
            <div className="user-avatar">
              <User size={20} />
            </div>
          </div>
        </div>
      </div> */}
    </header>
  );
};

export default Header;
